/** moderator/transcriptions — API (backed by portal-backend matches-info). */
import { http } from '../../_shared/http';
import type { WorldEntry, TeamEntry, MatchEntry } from './types';

const seg = encodeURIComponent;
const base = (path: string) => `/matches-info${path}`;

export const transcriptionsApi = {
  listWorlds: async (): Promise<WorldEntry[]> =>
    (await http.get<{ worlds: WorldEntry[] }>(base('/worlds'))).worlds,

  listTeams: async (gameName: string, worldName: string): Promise<TeamEntry[]> =>
    (await http.get<{ teams: TeamEntry[] }>(base(`/${seg(gameName)}/${seg(worldName)}/teams`))).teams,

  listMatches: async (gameName: string, worldName: string, cohortId: string): Promise<MatchEntry[]> =>
    (await http.get<{ matches: MatchEntry[] }>(base(`/${seg(gameName)}/${seg(worldName)}/${seg(cohortId)}/matches`))).matches,

  getFile: <T = unknown>(gameName: string, worldName: string, cohortId: string, matchFolder: string, filename: string) =>
    http.get<T>(base(`/${seg(gameName)}/${seg(worldName)}/${seg(cohortId)}/${seg(matchFolder)}/${seg(filename)}`)),

  getSignedUrl: (gameName: string, worldName: string, cohortId: string, matchFolder: string, filename: string) =>
    http.get<{ url: string; expiresAt: string }>(
      base(`/${seg(gameName)}/${seg(worldName)}/${seg(cohortId)}/${seg(matchFolder)}/${seg(filename)}/signed-url`),
    ),

  deleteWorld: (gameName: string, worldName: string) =>
    http.del<void>(base(`/${seg(gameName)}/${seg(worldName)}`)),
};
